import dynamic from "next/dynamic";

// Every page template used to be statically imported here, which bundled
// all ~29 templates (and their dependencies) into every page's JS chunk.
// next/dynamic splits each template into its own chunk: pages ship only
// the template they render. SSR stays on (the default), so the templates
// are still rendered into the exported static HTML at build time and Next
// preloads the matching chunk — hydration does not gain a network
// round-trip.
export const PageComponents = {
  Automation: dynamic(() => import("./automation").then((m) => m.Automation)),
  Blogs: dynamic(() => import("./blogs").then((m) => m.Blogs)),
  CentralBanks: dynamic(() =>
    import("./central-banks").then((m) => m.CentralBanks)
  ),
  ClearingInstitutions: dynamic(() =>
    import("./clearing-institutions").then((m) => m.ClearingInstitutions)
  ),
  ContactUs: dynamic(() => import("./contact-us").then((m) => m.ContactUs)),
  Ecosystem: dynamic(() => import("./ecosystem").then((m) => m.Ecosystem)),
  EndUserApps: dynamic(() =>
    import("./end-user-apps").then((m) => m.EndUserApps)
  ),
  Home: dynamic(() => import("./home").then((m) => m.Home)),
  Insights: dynamic(() => import("./insights").then((m) => m.Insights)),
  Investor: dynamic(() => import("./investor").then((m) => m.Investor)),
  JoinOurTeam: dynamic(() =>
    import("./join-our-team").then((m) => m.JoinOurTeam)
  ),
  LeadGen: dynamic(() => import("./lead-gen").then((m) => m.LeadGen)),
  Leadership: dynamic(() => import("./leadership").then((m) => m.Leadership)),
  Legal: dynamic(() => import("./legal").then((m) => m.Legal)),
  News: dynamic(() => import("./news").then((m) => m.News)),
  OriginatingInstitutions: dynamic(() =>
    import("./originating-institutions").then((m) => m.OriginatingInstitutions)
  ),
  PayallLife: dynamic(() =>
    import("./payall-life").then((m) => m.PayallLife)
  ),
  PayallStory: dynamic(() =>
    import("./payall-story").then((m) => m.PayallStory)
  ),
  PaymentChannels: dynamic(() =>
    import("./payment-channels").then((m) => m.PaymentChannels)
  ),
  PaymentNetworks: dynamic(() =>
    import("./payment-networks").then((m) => m.PaymentNetworks)
  ),
  PaymentOrchestration: dynamic(() =>
    import("./payment-orchestration").then((m) => m.PaymentOrchestration)
  ),
  Platform: dynamic(() => import("./platform").then((m) => m.Platform)),
  Posts: dynamic(() => import("./posts").then((m) => m.Posts)),
  Resources: dynamic(() => import("./resources").then((m) => m.Resources)),
  Solutions: dynamic(() => import("./solutions").then((m) => m.Solutions)),
  UniversalPaymentAccount: dynamic(() =>
    import("./universal-payment-account").then((m) => m.UniversalPaymentAccount)
  ),
  P2pMoneyAbroad: dynamic(() =>
    import("./p2p-money-abroad").then((m) => m.P2pMoneyAbroad)
  ),
  Search: dynamic(() => import("./search").then((m) => m.Search)),
  Error: dynamic(() => import("./error").then((m) => m.Error)),
};

export type PageComponentKeys = keyof typeof PageComponents;
